import { SET_USER, CLEAR_PASSWORD_CHANGE_REQUIRED, SET_DEPLOYMENT_TYPE } from './constants'
const initState = {
 user: '',
 userId: '',
 userType: '',
 locale: '',
 viewpermissions: {},
 doctypepermissions: {},
 localisation: {},
 requirePasswordChange: false,
 deploymentType: null
}
export default (state = initState, action) => {
    switch(action.type) {
    case SET_USER :
        return { ...state, user: action.payload.user, userId: action.payload.userId, userType: action.payload.userType, locale: action.payload.locale, viewpermissions: action.payload.viewpermissions, doctypepermissions: action.payload.doctypepermissions, localisation: action.payload.localisation, requirePasswordChange: action.payload.requirePasswordChange ?? false }
    case CLEAR_PASSWORD_CHANGE_REQUIRED:
        return { ...state, requirePasswordChange: false }
    case SET_DEPLOYMENT_TYPE:
        return { ...state, deploymentType: action.payload }
    default :
        return state
 }
}
